import { combineReducers } from 'redux'

import attendance from './attendance'
import attendanceNotExcludingHoliday from './attendance-not-excluding-holiday'
import businessTravel from './business-travel'
import catShift from './cat-shift'
import email from './email'
import factory from './factory'
import orgStructure from './org-structure'
import overtime from './overtime'
import pickupPoint from './pickup-point'
import position from './position'
import profileCustom from './profile-custom'
import reportAll from './report-all'
import reportBr11 from './report-br11'
import reportBusNotCheckIn from './report-bus-not-check-in'
import reportBusinessTravelNotCheckIn from './report-business-travel-not-check-in'
import reportCheckInEmployee from './report-check-in-employee'
import reportFee from './report-fee'
import reportOt from './report-ot'
import rosterCalendar from './roster-calendar'
import route from './route'
import routePointRegister from './route-point-register'
import setting from './setting'
import settingAutoApproval from './setting-auto-approval'
import vehicleCategories from './vehicle-categories'
import vehicleRegister from './vehicle-register'
import workSchedule from './work-schedule'

export default combineReducers({
  pickupPoint,
  route,
  businessTravel,
  profileCustom,
  overtime,
  workSchedule,
  catShift,
  orgStructure,
  factory,
  attendance,
  vehicleCategories,
  position,
  rosterCalendar,
  reportBr11,
  reportAll,
  reportOt,
  setting,
  email,
  reportFee,
  vehicleRegister,
  routePointRegister,
  reportCheckInEmployee,
  reportBusinessTravelNotCheckIn,
  reportBusNotCheckIn,
  settingAutoApproval,
  attendanceNotExcludingHoliday,
})
